import { productSlice } from "./store/product.slice";
import {
  productApi,
  useGetProductsQuery,
  useCreateProductMutation,
  useUpdateProductMutation,
  useLazyGetProductByIdQuery,
  useLazyGetProductsQuery,
  useDeleteProductMutation,
  useReorderProductsMutation,
} from "./api/product.api";

export const { setProducts } = productSlice.actions;

export {
  productApi,
  productSlice,
  useReorderProductsMutation,
  useGetProductsQuery,
  useCreateProductMutation,
  useUpdateProductMutation,
  useLazyGetProductByIdQuery,
  useLazyGetProductsQuery,
  useDeleteProductMutation
};
